import { useEffect } from 'react';
import { useUserPurchasesQuery, ownedMapsFromPurchases } from '../hooks/queries/useUserPurchasesQuery';
import { actionTypes } from '../contexts/AppContext';

/** Syncs shop user purchases into AppContext owned maps when authenticated. */
export function UserPurchasesQuerySync({ dispatch, isAuthenticated }) {
  const query = useUserPurchasesQuery(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    dispatch({ type: actionTypes.SET_OWNED_LOADING, payload: query.isFetching });
  }, [dispatch, isAuthenticated, query.isFetching]);

  useEffect(() => {
    if (!isAuthenticated || !query.data) {
      return;
    }
    const { trackUuids, albumIds } = ownedMapsFromPurchases(query.data);
    dispatch({
      type: actionTypes.SET_OWNED,
      payload: { trackUuids, albumIds, loadedAt: new Date().toISOString() },
    });
  }, [dispatch, isAuthenticated, query.data]);

  return null;
}
